module.exports = __webpack_public_path__ + "img/icon_present3.0ac2c6f9.svg";